import { useContext } from "react";
import { AlertContext } from "../Provider/AlertProvider";

export default function useAlert() {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error("useAlert must be used within a DropDownProvider");
  }
  return context;
}
